class ROICalc {
    constructor() {
        this.providerPrice = null;
        this.sendifyPrice = null;
        this.saved = null;
        this.priceTable = null;
        this.curWeight = '';
        this.average = null;
    }

    init(weight, week, where, average, form, submit, results, providerPrice, sendifyPrice, save, priceTable) {
        this.weightBlock = weight;
        this.week = week;
        this.where = where;
        this.average = average;
        this.form = form;
        this.submit = submit;
        this.resultsBlock = results;
        this.providerPriceBlock = providerPrice;
        this.sendifyPriceBlock = sendifyPrice;
        this.saveBlock = save;
        this.priceTable = priceTable;
        this.average.setAttribute('max', this.priceTable[this.where.value].table_price.length -1);
    }

    get getCurrentWeight() {
        return this.priceTable[this.getWhere].table_price[this.getAverage].weight ? this.priceTable[this.getWhere].table_price[this.getAverage].weight : ''
    }

    get getWeek() {
        return this.week.value ? parseInt(this.week.value) : null
    }

    get getWhere() {
        return /^-?\d+$/.test(this.where.value) ? this.where.value : null
    }

    get getAverage() {
        return this.average.value ? parseInt(this.average.value) : null
    }

    get getProviderPrice() {
        return (this.getWeek * this.priceTable[this.getWhere].table_price[this.getAverage].other).toFixed(2);
    }

    get getSendifyPrice() {
        return (this.getWeek * this.priceTable[this.getWhere].table_price[this.getAverage].sendify).toFixed(2);
    }

    get getSaved(){
        if(!this.providerPrice || !this.sendifyPrice) return null;
        return (100 - (this.sendifyPrice * 100 / this.providerPrice)).toFixed();
    }

    get getSavedCurrency(){
        if(!this.providerPrice || !this.sendifyPrice) return null;
        return (this.sendifyPrice - this.providerPrice).toFixed(2);
    }

    set setProviderPrice(price) {
        this.providerPrice = price;
    }

    set setSendifyPrice(price) {
        this.sendifyPrice = price;
    }

    set setSaved(price) {
        this.saved = price;
    }

    set setCurrentWeight(weight) {
        this.curWeight = this.priceTable[this.getWhere].table_price[this.getAverage].weight ? this.priceTable[this.getWhere].table_price[this.getAverage].weight : '';
    }

    set setAverage(priceTable) {
        this.average.setAttribute('max', this.priceTable[this.getWhere].table_price.length -1);
    }

    clearResults() {
        if (this.sendifyPrice && this.providerPrice) {
            this.setProviderPrice = null;
            this.setSendifyPrice = null;
            this.setSaved = null;
            this.hide(this.resultsBlock);
            this.submit.removeAttribute('disabled');
        }
    }

    hide(element) {
        element.style.opacity = 0;
    }

    show(element) {
        element.style.opacity = 1;
    }

    setOutput(element, value) {
        if (!element || !value) return;
        element.innerHTML = value;
    }

    setValue(element, value) {
        if (!element || !value) return;
        element.value = value;
    }
}

export default ROICalc;



// WEBPACK FOOTER //
// ./scripts/modules/roiCalc.js